export default {
  baseStyle: {
    fontWeight: 500,
    padding: '4px 16px',
  },
  variants: {
    incomplete: {
      backgroundColor: 'gray.200',
      color: 'black',
    },
    current: {
      backgroundColor: 'orange.400',
      color: 'white',
      fontWeight: 600,
    },
    complete: {
      backgroundColor: 'blue.900',
      color: 'white',
    },
  },
}
